<div class="container">
  @if (stores?.length) {
    <div data-automation="der-table-container">
      <table data-automation="der-table" mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="type">
            {{ 'der.type' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-type">
            @switch (store['derType']) {
              @case ('DEN-STORE') {
                <img src="assets/svg-icons/battery2.svg" class="images" alt="capacity" />
              }
              @case ('FUEL-CELL') {
                <img src="assets/svg-icons/fuel-cell2.svg" class="images" alt="fuel-cell" />
              }
              @case ('SOLAR') {
                <img src="assets/svg-icons/solar-energy1.svg" class="images" alt="solar-energy" />
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="available">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="availabile">
            {{ 'der.available' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-available">
            @if (store['available']) {
              <img src="assets/svg-icons/allow.svg" class="images" alt="green" />
            } @else {
              <img src="assets/svg-icons/deny.svg" class="images" alt="red" />
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
            {{ 'der.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-name">
            {{ store.displayLabel }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="status">
            {{ 'der.status' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-oem">
            {{ store.status ?? ('der.status.unavailable' | translate) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="soc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="soc">
            {{ 'der.soc' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-rack-batteries">
            {{ store.soc }}
            @if (store.soc !== undefined && store.soc !== null) {
              %
            } @else {
              -
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="usableEnergy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="usableEnergy">
            {{ 'der.usable_energy' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-usable-energy">
            {{ store.usableEnergy | number: '1.0-0' }}
            @if (store.usableEnergy !== undefined && store.usableEnergy !== null) {
              kW
            } @else {
              -
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="nameplateEnergy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="nameplateEnergy">
            {{ 'der.nameplate_energy' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-nameplate-energy">
            {{ store.nameplateEnergy | number: '1.0-0' }}
            @if (store.nameplateEnergy !== undefined && store.nameplateEnergy !== null) {
              kW
            } @else {
              -
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="currentPower">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="currentPower">
            {{ 'der.current_power' | translate }}
          </th>
          <td mat-cell *matCellDef="let store" data-automation="der-table-current-power">
            {{ store.power | number: '1.0-0' }}
            @if (store.power !== undefined && store.power !== null) {
              kW
            } @else {
              -
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let store; columns: displayedColumns" id="{{ 'store-table-' + store.id }}"></tr>
      </table>

      @if (stores?.length > 10) {
        <mat-paginator
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
          aria-label="Select page of stores"
        ></mat-paginator>
      }
    </div>
  }
</div>
